const CITY_NAMES: Record<string, string> = {
  sochi: "Сочи",
  las_vegas: "Лас-Вегас",
  macau: "Макао",
  monte_carlo: "Монте-Карло",
  bogota: "Богота",
  crystal: "Кристалл",
  lux: "Люкс",
  barcelona: "Барселона",
  san_jose: "Сан-Хосе",
  london: "Лондон",
  singapore: "Сингапур",
};

export function isKnownCity(cityId: string): boolean {
  return cityId in CITY_NAMES;
}

export function getCityName(cityId: string): string {
  return CITY_NAMES[cityId] ?? cityId;
}

export function getCityVoucherIcon(cityId: string): string {
  return `/vouchers/${cityId}.webp`;
}
